import BaseService from './base.service';

export default class PropertyVisitorService {
    static ENDPOINT = '/properties';

    static async getVisitors(propertyId) {
        const endpoint = `${this.ENDPOINT}/${propertyId}/visitors`;
        return BaseService.get(endpoint);
    }

    static async getVisitorById(propertyId, visitorId) {
        const endpoint = `${this.ENDPOINT}/${propertyId}/visitors/${visitorId}`;
        return BaseService.get(endpoint);
    }

    static async addVisitor(propertyId, visitorData) {
        const endpoint = `${this.ENDPOINT}/${propertyId}/visitors`;
        return BaseService.post(endpoint, visitorData);
    }

    static async updateVisitor(propertyId, visitorId, visitorData) {
        const endpoint = `${this.ENDPOINT}/${propertyId}/visitors/${visitorId}`;
        return BaseService.patch(endpoint, visitorData);
    }

    static async removeVisitor(propertyId, visitorId) {
        const endpoint = `${this.ENDPOINT}/${propertyId}/visitors/${visitorId}/remove`;
        return BaseService.patch(endpoint, null);
    }

    static async suspendVisitor(propertyId, visitorId, suspended) {
        const endpoint = `${this.ENDPOINT}/${propertyId}/visitors/${visitorId}/suspend`;
        return BaseService.patch(endpoint, { suspended: suspended });
    }
}
